var _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.014,
    cy: 6,
    rx: 1.014,
    ry: 1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.014,
    cy: 12,
    rx: 1.014,
    ry: 1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.014,
    cy: 18,
    rx: 1.014,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.057 5H20.24v2H7.057zM7.057 11H20.24v2H7.057zM7.057 17H20.24v2H7.057z"
  })));
};
export { SvgList as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgImRhdGE6aW1hZ2Uvc3ZnK3htbDtiYXNlNjQsUEhOMlp5QjNhV1IwYUQwaU1qUWlJR2hsYVdkb2REMGlNalFpSUhacFpYZENiM2c5SWpBZ01DQXlOQ0F5TkNJZ1ptbHNiRDBpWTNWeWNtVnVkRU52Ykc5eUlpQnpkSEp2YTJVOUltNXZibVVpSUhodGJHNXpQU0pvZEhSd09pOHZkM2QzTG5jekxtOXlaeTh5TURBd0wzTjJaeUkrQ2lBZ1BHVnNiR2x3YzJVZ1kzZzlJalF1TURFME1EZ2lJR041UFNJMklpQnllRDBpTVM0d01UUXdPQ0lnY25rOUlqRWlJQzgrQ2lBZ1BHVnNiR2x3YzJVZ1kzZzlJalF1TURFME1EZ2lJR041UFNJeE1pSWdjbmc5SWpFdU1ERTBNRGdpSUhKNVBTSXhJaUF2UGdvZ0lEeGxiR3hwY0hObElHTjRQU0kwTGpBeE5EQTRJaUJqZVQwaU1UZ2lJSEo0UFNJeExqQXhOREE0SWlCeWVUMGlNU0lnTHo0S0lDQThjbVZqZENCNFBTSTNMakExTmpZMElpQjVQU0kxSWlCM2FXUjBhRDBpTVRNdU1UZ3pNU0lnYUdWcFoyaDBQU0l5SWlBdlBnb2dJRHh5WldOMElIZzlJamN1TURVMk5qUWlJSGs5SWpFeElpQjNhV1IwYUQwaU1UTXVNVGd6TVNJZ2FHVnBaMmgwUFNJeUlpQXZQZ29nSUR4eVpXTjBJSGc5SWpjdU1EVTJOalFpSUhrOUlqRTNJaUIzYVdSMGFEMGlNVE11TVRnek1TSWdhR1ZwWjJoMFBTSXlJaUF2UGdvOEwzTjJaejRLIg==";